import React, { useState } from 'react';

import { NavbarNew, SidebarNew } from "../components/Navigation";
import Footer from "../components/Footer";
import Header from "../components/Header";

import s from "../styles/objetosPerdidos.module.css"
import cx from "classnames"

export default function ObjetosPerdidos() {

    const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    mensaje: ''
  });
  
    const ContactForm = () => {
        const [formData, setFormData] = useState({
            nombre: '',
            email: '',
            mensaje: ''
    })};
    
    const [status, setStatus] = useState('idle'); // idle, loading, success, error
    
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('loading');
        try {
            // Hacemos la petición a NUESTRO backend, no a Resend directamente
            const response = await fetch('https://react.granacuario.com/send.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            
            if (response.ok) {
                setStatus('success');
                setFormData({ nombre: '', email: '', mensaje: '' }); // Limpiar form
            } else {
                setStatus('error');
            }
        } catch (error) {
            console.error('Error:', error);
            setStatus('error');
        }
    };

    return (
        <>
            <NavbarNew/>
            <SidebarNew/>
            <Header routeName="objetosPerdidos" altName="Acuario Vista Aérea" titleText="OBJETOS PERDIDOS Y OLVIDADOS"/>

            {/* Compromiso */}
            <div className={ cx(s.compromiso_section, 'section') }>
                <div className={ cx(s.compromiso_img) }>
                    <img src="/images/objetosPerdidos/compromiso.png" srcSet="/images/objetosPerdidos/compromiso.webp" alt="Familia en GAM" title="Familia en GAM"/>
                </div>
                <div className={ cx(s.compromiso_des) }>
                    <div className={ cx(s.compromiso_des_title) }>En el Gran Acuario Mazatlán, nos comprometemos a brindar a nuestros visitantes una experiencia segura, ordenada y confiable. Para ello, contamos con un protocolo de atención, registro y resguardo de objetos perdidos u olvidados dentro de nuestras instalaciones.</div>
                </div>
            </div>

            {/* Proceso de atención */}
            <div className={ cx(s.proceso_section, 'section') }>
                <div className={ cx(s.proceso_content, 'content') }>
                    <div className={ cx(s.proceso_title, s.title) }>PROCEDIMIENTO DE ATENCIÓN<span></span></div>
                    <div className={ cx(s.proceso_subtitle, s.subtitle) }>RECEPCIÓN Y REGISTRO</div>
                    <div className={ cx(s.proceso_des) }>Todo objeto encontrado en el interior del Acuario es recibido por el personal de seguridad, quien realiza un registro detallado que incluye la descripción, lugar, fecha y hora del hallazgo. Posteriormente, el objeto se resguarda en un área segura con acceso controlado.</div>
                    <div className={ cx(s.proceso_des, s.proceso_des_dis) }>Los artículos de valor se almacenan bajo resguardo especial.</div>
                    
                    <div className={ cx(s.proceso_subtitle, s.subtitle) }>RECLAMO Y ENTREGA</div>
                    <div className={ cx(s.proceso_des) }>En caso de requerir hacer un reporte sobre un objeto extraviado durante la estancia en el acuario, el visitante deberá acercarse con el personal de Seguridad para verificar si el objeto ha sido localizado o de lo contrario realizar un reporte.</div>
                    <div className={ cx(s.proceso_des, s.proceso_des_dis) }>Para realizar el reporte será necesario:</div>
                    <div className={ cx(s.proceso_des) }>- Proporcionar una descripción precisa del artículo.</div>
                    <div className={ cx(s.proceso_des) }>- Brindar un contacto para recibir información</div>
                    <div className={ cx(s.proceso_des) }>Para que el personal de seguridad pueda iniciar con la búsqueda.</div>
                    <div className={ cx(s.proceso_des, s.proceso_des_dis) }>En caso de contar con el artículo descrito:</div>
                    <div className={ cx(s.proceso_des) }>- Deberá presentar identificación oficial vigente y firmar hoja de recepción.</div>
                    <div className={ cx(s.proceso_des) }>- Una vez confirmada la propiedad, se procederá a la entrega del objeto conforme a nuestros registros internos.</div> 

                    <div className={ cx(s.proceso_subtitle, s.subtitle) }>PERIODO DE RESGUARDO</div>
                    <div className={ cx(s.proceso_des) }>Todo objeto encontrado en el interior del Acuario es recibido por el personal de seguridad, quien realiza un registro detallado que incluye la descripción, lugar, fecha y hora del hallazgo. Posteriormente, el objeto se resguarda en un área segura con acceso controlado. El objeto se resguarda durante 2 meses a partir del día en el cual se reporta o se da recepción y se mantiene en un área de acceso controlado.</div>
                    <div className={ cx(s.proceso_des, s.proceso_des_dis) }>Los artículos de valor se almacenan bajo resguardo especial.</div> 

                    <div className={ cx(s.proceso_subtitle, s.subtitle) }>¿CÓMO NOTIFICO MI OBJETO PERDIDO?</div>
                    <div className={ cx(s.proceso_des) }>Te debes contactar vía correo electrónico al email <a href="mailto:objetosperdidos@granacuario.com">objetosperdidos@granacuario.com</a> y contarnos lo siguiente:</div>
                    <div className={ cx(s.proceso_des) }>Tu nombre, teléfono, una descripción de tu objeto que nos ayude a identificarlo (marca, modelo, color, características únicas), lugar exacto donde crees que lo perdiste junto con la fecha y hora.</div>
                    <div className={ cx(s.proceso_des, s.proceso_des_dis) }>Recibiremos tu información y nos contactaremos a la brevedad contigo para darte solución.</div> 
                </div>
                <div className={ cx(s.proceso_medusa_con) }>
                    <img className={ cx(s.proceso_medusa) } src="/images/objetosPerdidos/medusa.png" srcSet="/images/objetosPerdidos/medusa.webp" alt="Medusa" title="Medusa" />
                </div>
            </div>

            {/* Formulario
            <div className={ cx(s.formulario_section, 'section') }>
                <div className={ cx(s.formulario_content, 'content') }>
                    <div className={ cx(s.proceso_title, s.title) }>FORMULARIO<span></span></div>
                    <div className={ cx(s.formulario_des) }>Favor de llenar el siguiente formulario con todos los datos</div>
                    <form className={ cx(s.formulario_form) } onSubmit={handleSubmit}>
                        <div className={ cx(s.formulario_form_con) }>
                            <div className={ cx(s.fomulario_el) }>
                                <div>Nombre completo</div>
                                <input type="text" name="nombre" value={formData.nombre} onChange={handleChange} required/>
                            </div>
                            <div className={ cx(s.fomulario_el_dos) }>
                                <div className={ cx(s.fomulario_el) }>
                                    <div>Teléfono</div>
                                    <input type="text" name="telefono" value={formData.telefono} onChange={handleChange} required/>
                                </div>
                                <div className={ cx(s.fomulario_el) }>
                                    <div>Correo</div>
                                    <input type="text" name="correo" value={formData.correo} onChange={handleChange} required/>
                                </div>
                            </div>
                            <div className={ cx(s.fomulario_el) }>
                                <div>Describa el objeto perdido (marca, modelo, color, características únicas):</div>
                                <textarea name="mensaje" value={formData.mensaje} onChange={handleChange} required rows="4" style={{ padding: '10px' }}/>
                            </div>
                            <div className={ cx(s.fomulario_el) }>
                                <div>Lugar exacto donde cree que lo perdió</div>
                                <input type="text" name="lugar" value={formData.lugar} onChange={handleChange} required/>
                            </div>
                            <div className={ cx(s.fomulario_el_dos) }>
                                <div className={ cx(s.fomulario_el) }>
                                    <div>Fecha</div>
                                    <input type="text" name="fecha" value={formData.fecha} onChange={handleChange} required/>
                                </div>
                                <div className={ cx(s.fomulario_el) }>
                                    <div>Hora</div>
                                    <input type="text" name="hora" value={formData.hora} onChange={handleChange} required/>
                                </div>
                            </div>                            
                        </div>
                        <div className={ cx(s.fomulario_el_btn) }>
                            <button className={ cx(s.formulario_el_btn) } type="submit" disabled={status === 'loading'} >
                                {status === 'loading' ? 'Enviando...' : 'Enviar'}
                            </button>
                            {status === 'success' && <div className={ cx(s.formulario_el_msg) } style={{ color: 'green' }}>¡Mensaje enviado con éxito!</div>}
                            {status === 'error' && <div className={ cx(s.formulario_el_msg) } style={{ color: 'red' }}>Hubo un error al enviar el mensaje.</div>}
                        </div>
                    </form>
                </div>
            </div> */}

            {/* Información y contacto */}
            <div className={ cx(s.info_section, 'section') }>
                <div className={ cx(s.info_content, 'content') }>
                    <div className={ cx(s.proceso_title, s.title) }>INFORMACIÓN Y CONTACTO<span></span></div>
                    <div className={ cx(s.info_con) }>
                        <div className={ cx(s.info_img) }>
                            <img src="/images/objetosPerdidos/info.png" srcSet="/images/objetosPerdidos/info.webp" alt="Pareja en el acuario" title="Pareja en el acuario" />
                        </div>
                        <div className={ cx(s.info_des) }>
                            <img className={ cx(s.info_des_bg) } src="/images/objetosPerdidos/bg.svg" alt="Background" title="Background" />
                            <div className={ cx(s.info_des_t1) }>Para más información o para realizar una consulta sobre objetos extraviados, puedes llamar al:</div>
                            <div className={ cx(s.info_des_t1) }><a href="tel:6696890501">Tel. (669) 689 0501</a></div>
                            <div className={ cx(s.info_des_t1) }>De igual forma puedes acudir directamente a Taquilla y pedir información al personal de Seguridad durante el horario de servicio.</div>
                            <div className={ cx(s.info_des_t1) }>Gran Acuario Mazatlán, comprometidos con la seguridad, transparencia y bienestar de nuestros  visitantes.</div>
                        </div>
                    </div>
                </div>
            </div>


            <Footer/>
        </>
    )
}